import React from 'react';

import { ReportOrderContraEntry } from '@/services/innovorder/orders/order.type';
import { SvyIcon } from '@innovorder/savory';
import { computeDate, computeText } from '@/locales/utils';
import { useIntl } from 'react-intl';
import {
    Container,
    ItemContainer,
    LinkContainer,
    LinkLabel,
    StyledLabel,
    StyledTitle,
} from './OrderDetailsLinkedOrder.style';

const OrderDetailsLinkedOrder: React.FunctionComponent<React.PropsWithChildren<ReportOrderContraEntry>> = ({
    type,
    originOrderDate,
    createdAt,
    originOrderPosId,
    contraEntryOrderPosId,
}) => {
    const intl = useIntl();

    return (
        <Container>
            <LinkContainer>
                <SvyIcon icon="link" />
                <LinkLabel to={`/orders/${type === 'origin' ? contraEntryOrderPosId : originOrderPosId}`}>
                    {computeText(intl, `orderDetail.linkedOrder.title.${type}`)}
                </LinkLabel>
            </LinkContainer>
            <ItemContainer>
                <StyledLabel text={`orderDetail.linkedOrder.date.${type}`} />
                <StyledTitle
                    type="small"
                    weight="medium"
                    text={computeDate(intl, type === 'origin' ? createdAt : originOrderDate)}
                    noTranslation
                />
            </ItemContainer>
        </Container>
    );
};

export default OrderDetailsLinkedOrder;
